import React, { useEffect } from 'react';
import { useLanguage } from '../utils/useLanguage';

const FooterWrapper = ({ data }) => {
    const { en, de } = data || {};

    const langFromPathname = window.location.pathname.split('/')[1];
    const initialLang =
        data && data[langFromPathname] ? langFromPathname : 'de';
    const { lang } = useLanguage(initialLang);

    const innerHTML = lang === 'en' ? en : de;

    useEffect(() => {
        // load cookie consent script
        const cookieConsentScript = document.createElement('script');
        cookieConsentScript.src =
            'https://www.sonnenalp.de/js/cookies.bundle.js?v=1.139.0';
        document.body.appendChild(cookieConsentScript);
    }, [innerHTML]);

    if (!innerHTML) return null;
    return <div dangerouslySetInnerHTML={{ __html: innerHTML }}></div>;
};

export default FooterWrapper;



// WEBPACK FOOTER //
// ./src/components/FooterWrapper.jsx